<div class="content-section mb-12">
  <ng-container [ngSwitch]="question.type">
    <app-single
      *ngSwitchCase="'single'"
      [question]="question"
      [index]="index"
      [isMissing]="isMissing"
      (answerSelected)="handleAnswerSelection($event)"
    ></app-single>
    <app-multiple-choice
      *ngSwitchCase="'multiple-choice'"
      [question]="question"
      [index]="index"
      [isMissing]="isMissing"
      (answerSelected)="handleAnswerSelection($event)"
    ></app-multiple-choice>
    <app-agree-disagree
      *ngSwitchCase="'agree-disagree'"
      [question]="question"
      [index]="index"
      [isMissing]="isMissing"
      (answerSelected)="handleAnswerSelection($event)"
    ></app-agree-disagree>
    <app-poor-excellent
      *ngSwitchCase="'poor-excellent'"
      [question]="question"
      [index]="index"
      [isMissing]="isMissing"
      (answerSelected)="handleAnswerSelection($event)"
    ></app-poor-excellent>
    <app-never-always
      *ngSwitchCase="'never-always'"
      [question]="question"
      [index]="index"
      [isMissing]="isMissing"
      (answerSelected)="handleAnswerSelection($event)"
    ></app-never-always>
    <app-semantic-ability
      *ngSwitchCase="'semantic-ability'"
      [question]="question"
      [index]="index"
      [isMissing]="isMissing"
      (answerSelected)="handleAnswerSelection($event)"
    ></app-semantic-ability>
    <app-semantic-neutral
      *ngSwitchCase="'semantic-neutral'"
      [question]="question"
      [index]="index"
      [isMissing]="isMissing"
      (answerSelected)="handleAnswerSelection($event)"
    ></app-semantic-neutral>
    <app-poor-outstanding
      *ngSwitchCase="'poor-outstanding'"
      [question]="question"
      [index]="index"
      [isMissing]="isMissing"
      (answerSelected)="handleAnswerSelection($event)"
    ></app-poor-outstanding>
    <app-novice-expert
      *ngSwitchCase="'novice-expert'"
      [question]="question"
      [index]="index"
      [isMissing]="isMissing"
      (answerSelected)="handleAnswerSelection($event)"
    ></app-novice-expert>
    <app-likert-scale-1
      *ngSwitchCase="'likert-scale-1'"
      [question]="question"
      [index]="index"
      [isMissing]="isMissing"
      (answerSelected)="handleAnswerSelection($event)"
    ></app-likert-scale-1>
    <app-likert-scale-2
      *ngSwitchCase="'likert-scale-2'"
      [question]="question"
      [index]="index"
      [isMissing]="isMissing"
      (answerSelected)="handleAnswerSelection($event)"
    ></app-likert-scale-2>
    <app-likert-scale-3
      *ngSwitchCase="'likert-scale-3'"
      [question]="question"
      [index]="index"
      [isMissing]="isMissing"
      (answerSelected)="handleAnswerSelection($event)"
    ></app-likert-scale-3>
    <app-likert-scale-4
      *ngSwitchCase="'likert-scale-4'"
      [question]="question"
      [index]="index"
      [isMissing]="isMissing"
      (answerSelected)="handleAnswerSelection($event)"
    ></app-likert-scale-4>
    <app-multiple-select
      *ngSwitchCase="'multiple-select'"
      [question]="question"
      [index]="index"
      [isMissing]="isMissing"
      (answerSelected)="handleAnswerSelection($event)"
    ></app-multiple-select>
    <app-choice-with-opinion
      *ngSwitchCase="'choice-with-opinion'"
      [question]="question"
      [index]="index"
      [isMissing]="isMissing"
      (answerSelected)="handleAnswerSelection($event)"
    ></app-choice-with-opinion>
    <app-semantic-yes
      *ngSwitchCase="'semantic-yes'"
      [question]="question"
      [index]="index"
      [isMissing]="isMissing"
      (answerSelected)="handleAnswerSelection($event)"
    ></app-semantic-yes>
    <app-semantic-high
      *ngSwitchCase="'semantic-high'"
      [question]="question"
      [index]="index"
      [isMissing]="isMissing"
      (answerSelected)="handleAnswerSelection($event)"
    ></app-semantic-high>

    <app-only-image
      *ngSwitchCase="'only-image'"
      [question]="question"
      [index]="index"
      [isMissing]="isMissing"
      (answerSelected)="handleAnswerSelection($event)"
    ></app-only-image>

    <app-word-cloud
      *ngSwitchCase="'word-cloud'"
      [question]="question"
      [index]="index"
      [isMissing]="isMissing"
      (answerSelected)="handleAnswerSelection($event)"
    ></app-word-cloud>

    <app-open-response
      *ngSwitchCase="'open-response'"
      [question]="question"
      [index]="index"
      [isMissing]="isMissing"
      (answerSelected)="handleAnswerSelection($event)"
    ></app-open-response>

    <app-parent
      *ngSwitchCase="'parent'"
      [question]="question"
      [index]="index"
      [isMissing]="isMissing"
      [missingQuestionUuids]="missingQuestionUuids"
      (answerSelected)="handleAnswerSelection($event)"
      (answered)="answered.emit($event)"
    ></app-parent>
  </ng-container>
</div>
